import React, { useState } from "react";
import { Flex, Text, Button } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import AttendeeFilters from "./AttendeeFilters";
import AttendeeList from "./AttendeeList";
import { ATTENDEE_FILTERS } from "@utils/attendeeHelpers";

const AttendeeDetailView = ({
  response,
  activityType,
  options,
  participants = [],
  activityId,
  onBackToSummary,
  activity,
}) => {
  const [activeFilter, setActiveFilter] = useState(ATTENDEE_FILTERS.ALL);

  // Create a merged list of all participants with their response status
  // If no participants data is available, fallback to just showing the responses
  const attendees =
    participants.length > 0
      ? participants.map((participant) => {
          // Find if this participant has responded
          const participantResponse = response.find(
            (singleResponse) => singleResponse.user.userId === participant._id
          );

          if (participantResponse) {
            // Participant has responded - use their response data
            return {
              user: participantResponse.user,
              responseIds: participantResponse.responseIds,
              viewedAt: participantResponse.viewedAt,
              openedAt: participantResponse.openedAt,
              responseTime: participantResponse.responseTime,
              viewTime: participantResponse.viewTime,
              openedTime: participantResponse.openedTime,
            };
          } else {
            // Participant hasn't responded - create waiting entry
            return {
              user: {
                userId: participant._id,
                firstName: participant.firstName,
                lastName: participant.lastName,
                avatar: participant.avatar,
              },
              responseIds: null,
              viewedAt: null,
              openedAt: null,
              responseTime: null,
              viewTime: null,
              openedTime: null,
            };
          }
        })
      : // Fallback: Just show responses if no participants data
        response.map((singleResponse) => ({
          user: singleResponse.user,
          responseIds: singleResponse.responseIds,
          viewedAt: singleResponse.viewedAt,
          openedAt: singleResponse.openedAt,
          responseTime: singleResponse.responseTime,
          viewTime: singleResponse.viewTime,
          openedTime: singleResponse.openedTime,
        }));

  return (
    <Flex
      direction="column"
      gap={2}
      bg="#F9FAFB"
      p={3}
      borderRadius="8px"
      data-testid={`attendee-detail-view-${activityId || "default"}`}
    >
      <AttendeeFilters
        activityType={activityType}
        activeFilter={activeFilter}
        onFilterChange={setActiveFilter}
        activity={activity || { options }}
      />

      <AttendeeList
        attendees={attendees}
        activityType={activityType}
        options={options}
        activeFilter={activeFilter}
        activity={activity || { options }}
      />

      <Flex
        justify="center"
        align="center"
        gap={1}
        p={2.5}
        borderRadius="100px"
      >
        <Button
          variant="ghost"
          size="sm"
          p={0}
          h="auto"
          onClick={onBackToSummary}
          _hover={{ bg: "transparent" }}
          _active={{ bg: "transparent" }}
          data-testid="back-to-summary"
        >
          <Text
            fontSize="12px"
            fontWeight="600"
            color="#6533EE"
            lineHeight="18px"
          >
            Back to Summary
          </Text>
        </Button>
        <ChevronDownIcon
          w={3}
          h={3}
          color="#6533EE"
          transform="rotate(90deg)"
        />
      </Flex>
    </Flex>
  );
};

export default AttendeeDetailView;
